export class TypeAnomalies {
  static ADMINISTRATIF = 'ADMINISTRATIF';
  static RESULTATS = 'RESULTATS';
  static DOCUMENTS = 'DOCUMENTS';
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/constants/TypeAnomalie.ts